import React, { Component } from 'react';

import classnames from 'classnames';
import { connect } from 'react-redux';
import { WithStyles, withStyles } from '@mui/styles';

import APLabel from '../../atoms/APLabel';
import { ReducerState } from './../../../redux/modules';
import { withTranslate } from '../../../core/TenantProvider';

import APFooterStyles from './styles/APFooter.style';
import { CDSA_REFERRING_VALUE, TORFXOZ_REFERRING_VALUE } from '../../../core/utils/Constants/Constants';
import GetBasicDetails from '../../../core/utils/GetBasicDetails';

interface APFooterProps extends WithStyles<typeof APFooterStyles> {
  isAuthenticated: boolean | null,
  updateTranslations: Function,
  translate: Function
}

class APFooter extends Component<APFooterProps, {}> {
  render() {
    const {
      classes,
      isAuthenticated,
      translate
    } = this.props;

    const { referringCompany } = GetBasicDetails();
    const isCDSAReferringCompany: boolean = referringCompany === CDSA_REFERRING_VALUE;
    const isTorFXOzReferringCompany: boolean = referringCompany === TORFXOZ_REFERRING_VALUE;

    const footerContainerCls = classnames(classes.footerContainer, {
      [classes.footerContainerAuthenticated]: isAuthenticated && !isTorFXOzReferringCompany,
      [classes.footerContainerTorFXOz]: isAuthenticated && isTorFXOzReferringCompany
    })
    const showFooterLine3: boolean = isCDSAReferringCompany || isTorFXOzReferringCompany;
    const showFooterLine4: boolean = isTorFXOzReferringCompany;

    return (
      <div className={footerContainerCls}>
        <div className={classes.footerText}>
          <APLabel className={classes.footerLabel}>
            {translate('footer.copyright.line1')}
          </APLabel>
          <APLabel className={classes.footerLabel}>
            {translate('footer.copyright.line2')}
          </APLabel>
          {showFooterLine3 &&
            <APLabel className={classes.footerLabel}>
              {translate('footer.copyright.line3')}
            </APLabel>
          }
          {showFooterLine4 &&
            <APLabel className={classes.footerLabel}>
              {translate('footer.copyright.line4')}
            </APLabel>
          }
        </div>
        <div className={classes.appVersion}>
          v{process.env.REACT_APP_VERSION}
        </div>
      </div>
    )
  }
}

const mapStateToProps = (store: ReducerState) => ({
  isAuthenticated: store.user.isAuthenticated
});

export default connect(mapStateToProps)(
  withTranslate(withStyles(APFooterStyles)(APFooter))
);
